import { render } from "./AlertsDialog.vue?vue&type=template&id=6ed4d7a8"
import script from "./AlertsDialog.vue?vue&type=script&lang=js"
export * from "./AlertsDialog.vue?vue&type=script&lang=js"

import "./AlertsDialog.vue?vue&type=style&index=0&id=6ed4d7a8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__